import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deviceFilter'
})
export class DeviceFilterPipe implements PipeTransform {
  transform(chats: any[], deviceId: string, expanded: boolean): any[] {
    if (!chats || !deviceId) return [];

    return chats
      .filter(chat => chat.serial === deviceId)
      .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
      .slice(0, expanded ? 15 : 3);
  }
}